import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component AttachmentIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <AttachmentIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <AttachmentIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const AttachmentIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="AttachmentIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m12.814 2.454 1.414 1.414-8.485 8.486a4 4 0 0 0 5.512 5.794l.144-.138 8.132-8.131a1.5 1.5 0 0 0-2.014-2.219l-.107.097-8.58 8.58-1.414-1.414 8.58-8.58a3.5 3.5 0 0 1 5.082 4.81l-.133.14-8.131 8.132A6 6 0 0 1 4.172 11.1l.156-.162z"
      />
    </svg>
  )
);
AttachmentIcon.displayName = "AttachmentIcon";
export default AttachmentIcon;
